import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowPathIcon } from "@heroicons/react/24/solid";
import { AddFeedback } from "../../../../redux/reducer/feedbackReducer";

const AddFeedbackForm = ({ onClose }) => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const [name_en, setName_en] = useState("");
  const [name_ar, setName_ar] = useState("");
  const [desc_en, setDesc_en] = useState("");
  const [desc_ar, setDesc_ar] = useState("");
  const [rate, setRate] = useState("");

  const rateOptions = [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 bg-opacity-30bg-black">
      <div className="bg-white p-6 rounded-xl w-[90%] max-w-lg shadow-xl space-y-4">
        <h2 className="text-xl font-bold text-black">Add New feedBack</h2>

        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Name EN"
            className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
            value={name_en}
            onChange={(e) => setName_en(e.target.value)}
            required
          />
          <input
            type="text"
            placeholder="Name AR"
            className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
            value={name_ar}
            onChange={(e) => setName_ar(e.target.value)}
            required
          />
        </div>

        <div className="flex gap-2">
          <textarea
            type="text"
            placeholder="Short Description EN"
            className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
            value={desc_en}
            onChange={(e) => setDesc_en(e.target.value)}
            required
          />
          <textarea
            type="text"
            placeholder="Short Description AR"
            className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
            value={desc_ar}
            onChange={(e) => setDesc_ar(e.target.value)}
            required
          />
        </div>

        <div className="w-full">
          <select
            className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
            value={rate}
            onChange={(e) => setRate(e.target.value)}
            required
          >
            <option value="" className="text-black">
              Select Rate
            </option>
            {rateOptions.map((option) => (
              <option key={option} value={option} className="text-black">
                {option} ⭐
              </option>
            ))}
          </select>
        </div>

        <div className="flex justify-end gap-4">
          {isLoading ? null : (
            <button
              className="px-4 py-2 text-sm text-white duration-300 bg-gray-600 rounded-lg hover:bg-gray-800"
              onClick={onClose}
            >
              Cancel
            </button>
          )}
          {isLoading ? (
            <ArrowPathIcon className="w-10 h-10 p-2 text-white rounded-full animate-spin bg-custom-yellow" />
          ) : (
            <button
              className="px-4 py-2 text-sm text-black duration-300 rounded-lg hover:text-white bg-custom-yellow hover:bg-yellow-600"
              onClick={() => {
                setIsLoading(true);

                dispatch(
                  AddFeedback({
                    data: {
                      name_en,
                      name_ar,
                      desc_en,
                      desc_ar,
                      rate,
                    },
                  })
                )
                  .unwrap()
                  .then(() => {
                    alert("The feedBack has been added successfully.");
                  })
                  .catch((error) => {
                    alert("Failed to add the feedBack: " + error);
                  })
                  .finally(() => {
                    setIsLoading(false);
                    onClose();
                  });
              }}
            >
              Submit
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddFeedbackForm;
